import { useState } from "react";
import { MdOutlineMenu } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { IoLanguage } from "react-icons/io5";
import { useTranslation } from "react-i18next";

export default function Header() {
    const [show, setShow] = useState(false);
    const { i18n, t } = useTranslation();

    const changeLang = (langCode: string) => {
        i18n.changeLanguage(langCode);
        localStorage.setItem("lang", langCode);
    }

    const currentLang = i18n.language || "en";

    return (
        <header className="flex min-h-[10vh] flex-1 flex-wrap justify-between items-center py-5">
            <div className="flex flex-1 justify-between items-center mb-2 md:flex-none md:mb-0">
                <h1 className="font-semibold text-lg cursor-default">Bruno Curi</h1>
                <button className="md:hidden" onClick={() => setShow(!show)} aria-label={show ? "Close menu" : "Open menu"}>
                    {show ? (
                        <IoMdClose size="2em" />
                    ) : (
                        <MdOutlineMenu size="2em" />
                    )}
                </button>
            </div>

            <ul className={`${show ? "flex" : "hidden"} mb-2 border-darkBlue flex-col w-full gap-4 md:w-auto md:mb-0 md:flex md:flex-row md:gap-12`}>
                <li><a href="/" onClick={() => setShow(false)} className="block border-b-2 md:border-none hover:text-cyan transition duration-300">{t("home")}</a></li>
                <li><a href="#about" onClick={() => setShow(false)} className="block border-b-2 md:border-none hover:text-cyan transition duration-300">{t("about")}</a></li>
                <li><a href="#projects" onClick={() => setShow(false)} className="block border-b-2 md:border-none hover:text-cyan transition duration-300">{t("projects")}</a></li>
            </ul>

            <div className={`${show ? "flex" : "hidden"} ml-auto md:ml-0 md:flex border-2 border-darkBlue rounded-full p-1 px-3 gap-3 items-center bg-white shadow-sm`}>
                <IoLanguage className="text-darkBlue opacity-80" size="1.2em" aria-hidden="true" />
                <div className="flex gap-1 items-center">
                    <button 
                      onClick={() => changeLang("en")}
                      className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-300 ${currentLang.startsWith("en") ? "bg-darkBlue text-cyan" : "text-darkBlue hover:bg-cyan hover:bg-opacity-20"}`}
                      aria-pressed={currentLang.startsWith("en")}
                    >
                        EN
                    </button>
                    <div className="w-[1px] h-3 bg-darkBlue opacity-10"></div>
                    <button 
                      onClick={() => changeLang("es")}
                      className={`px-3 py-1 rounded-full text-xs font-bold transition-all duration-300 ${currentLang.startsWith("es") ? "bg-darkBlue text-cyan" : "text-darkBlue hover:bg-cyan hover:bg-opacity-20"}`}
                      aria-pressed={currentLang.startsWith("es")}
                    >
                        ES
                    </button>
                </div>
            </div>

        </header>
    );
}